import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  image: {
    maxWidth: '60%',
    borderRadius: '20px',
    objectFit: 'cover',
  },
}));

export default useStyles;
